import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const Contact2Icon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "Contact2IconGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}

      <path
        d="M16.4693 21.3449H12.5882C12.3067 21.3449 12.0789 21.1172 12.0789 20.8357C12.0789 20.5542 12.3067 20.3264 12.5882 20.3264H16.4693C16.9865 20.3264 17.4073 19.9057 17.4073 19.3884V11.1781C17.4073 10.8966 17.6351 10.6688 17.9165 10.6688C18.198 10.6688 18.4258 10.8966 18.4258 11.1781V19.3884C18.4258 20.4671 17.548 21.3449 16.4693 21.3449Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M12.6761 22.3826C13.5155 22.3826 14.1959 21.7021 14.1959 20.8628C14.1959 20.0234 13.5155 19.343 12.6761 19.343C11.8367 19.343 11.1563 20.0234 11.1563 20.8628C11.1563 21.7021 11.8367 22.3826 12.6761 22.3826Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M20.2987 18.9801H17.9151C17.6336 18.9801 17.4058 18.7524 17.4058 18.4709V11.0781C17.4058 10.7966 17.6336 10.5688 17.9151 10.5688H20.2987C21.6336 10.5688 22.7197 11.655 22.7197 12.9903V16.5591C22.7197 17.894 21.6336 18.9801 20.2987 18.9801ZM18.4243 17.9616H20.2987C21.0721 17.9616 21.7012 17.3325 21.7012 16.5591V12.9903C21.7012 12.2165 21.0721 11.5874 20.2987 11.5874H18.4243V17.9616Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M7.5249 18.9801H5.14121C3.80588 18.9801 2.71973 17.894 2.71973 16.5591V12.9903C2.71973 11.655 3.80589 10.5688 5.14121 10.5688H7.5249C7.80639 10.5688 8.03416 10.7966 8.03416 11.0781V18.4709C8.03416 18.7524 7.80639 18.9801 7.5249 18.9801ZM5.14121 11.5874C4.36737 11.5874 3.73825 12.2165 3.73825 12.9903V16.5591C3.73825 17.3325 4.36738 17.9616 5.14121 17.9616H7.01563V11.5874H5.14121Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M20.5787 11.5212C20.2972 11.5212 20.0695 11.3268 20.0695 11.0453V10.9786C20.0695 6.92592 16.7727 3.62863 12.72 3.62863C8.66726 3.62863 5.36997 6.92591 5.36997 10.9786C5.36997 11.2601 5.1422 11.5212 4.86071 11.5212C4.57922 11.5212 4.35145 11.3268 4.35145 11.0453C4.35145 6.36443 8.10577 2.61011 12.72 2.61011C17.3342 2.61011 21.088 6.36443 21.088 10.9786C21.088 11.2601 20.8602 11.5212 20.5787 11.5212Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
    </svg>
  );
};

export default Contact2Icon;
